import { baseValidators } from './builtins'
import { optionalValidators } from './optional'
import { OptionalValidatorKit, ValidatorKit } from './types'

/**
 * Exported namespace containing validators.
 */
export const v: ValidatorKit & { opt: OptionalValidatorKit } = {
  ...baseValidators,
  opt: optionalValidators
}